import { Sandbox } from "../classes/Sandbox.js";
import { useState } from "#imports";
export default function() {
  return useState("nuxt-color-picker:sandbox", () => new Sandbox());
}
